enum COURSES_LIST_TABS {
  YOUR_COURSES = 'your_courses',
  DIRECT_ACCESS = 'direct_access',
}

export default COURSES_LIST_TABS;
